import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.shared-accounts.request-center.requests.create', {
        url: '/create',
        views: {
            '@user.shared-accounts.request-center': 'createAccessRequest',
        },
        resolve: {companies},
    })
}

/** @ngInject */
function companies(RequestCenterService){
    return RequestCenterService.getCompanies();
}


// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/requests/create/create-access-request.state.js